var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.577.752a.657.657 0 0 0-.933 0L4.407 3.995 1.171.745a.657.657 0 0 0-.933 0 .664.664 0 0 0 0 .937l3.236 3.25-3.236 3.25a.664.664 0 0 0 0 .937c.258.26.675.26.933 0l3.236-3.25 3.237 3.25c.258.26.675.26.933 0a.664.664 0 0 0 0-.937l-3.236-3.25 3.236-3.25a.668.668 0 0 0 0-.93Z"
  })));
};
export default SvgCancel;